<template>
  <div v-editable="blok" card>
    <div v-if="blok?.image?.filename" class="card-image">
      <img :src="optimizeImage(blok.image.filename)" :alt="`Card Image ${blok.image.alt}`" loading="lazy" />
    </div>
    <div class="card-content">
      <div v-if="blok?.icon?.filename" class="card-icon">
        <img v-if="blok.icon?.filename" loading="lazy" :src="optimizeImage(blok.icon.filename)" :alt="`Card Icon ${blok.icon.alt}`" />
      </div>
      <label v-if="blok?.header" class="card-header" v-text="blok.header"></label>
      <h3 v-if="blok?.title" class="card-title" v-html="title"></h3>
      <div v-if="blok?.description" class="card-description" v-html="description"></div>
      <div v-if="blok?.buttons?.length > 0" class="card-buttons">
        <StoryblokComponent v-for="button in blok.buttons" :key="button._uid" :blok="button" />
      </div>
    </div>
  </div>
</template>
<script setup>
  const props = defineProps({ blok: Object });
  const title = computed(() => useRichText(props?.blok?.title || {}));
  const description = computed(() => useRichText(props?.blok?.description || {}));
  const link = computed(() => {
    if (props.blok?.buttons?.length === 0) return "/";
    return props.blok?.button[0].url?.cached_url || props.blok?.button[0].url?.url;
  });
</script>
<style src="~/assets/scss/section/card.scss" lang="scss"></style>
